module.exports = __webpack_public_path__ + "img/MO1A.bf88df94.png";